export default __webpack_public_path__ + "static/media/Shop-10.bd78cae3.webp";